import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-lifecycle-help-modal',
  templateUrl: './lifecycle-help-modal.component.pug',
  styleUrls: ['./lifecycle-help-modal.component.scss'],
  standalone: false
})
export class LifecycleHelpModalComponent implements OnInit {

  constructor(
    private modalService: BsModalService,
  ) { }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalService.hide()
  }

}
